<template>
    <div class="Login">
        <div class="isTest" :class="{'isTestCopy': userData.isSys != 0 ? false : true}" v-if="userId">
            <img  :src="require('../assets/bgc.png')" alt=""> 
            <div class="btnBox"  @click="startBtn(userId)">开始模拟</div>
            <!-- <div class="btnBox btn-ks"  @click="startKsBtn(userId)">考试</div> -->
            <!-- <div class="query-score-box">
                <span
                    @click="queryScoreClick"
                    >查询成绩</span>
            </div> -->
        </div>
        <div class="test" v-else>
            <div class="loginTitle">
                {{ isFindPwd ? '欢迎登录' : '找回密码' }}
            </div>
            <div class="loginMain">
                <div v-if="isFindPwd">
                    <el-form :model="formData" :rules="rules" ref="ruleForm">
                        <el-form-item label="" prop="mobile">
                            <el-input v-model.trim="formData.mobile" size="medium" readonly
                                onfocus="this.removeAttribute('readonly');" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input v-model.trim="formData.password" size="medium" readonly
                                onfocus="this.removeAttribute('readonly');" placeholder="请输入密码" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="validCode">
                            <div class="validCodeBox">
                                <el-input autocomplete="off" size="medium" @keyup.native.enter="goEnter"
                                    v-model.trim="formData.validCode" onfocus="this.removeAttribute('readonly');"
                                    type="text" placeholder="请输入验证码" maxlength="20" />
                                <img @click="getValidata" :src="ValidataUrl" />
                            </div>
                        </el-form-item>
                    </el-form>
                    <div class="forgetPwd"><span @click="() => {
                        isFindPwd = false; findData = {
                            mobile: '',
                            password: '',
                            repeatPwd: '',
                            validCode: ''
                        }
                    }">忘记密码</span></div>
                    <div class="btnBox" @click="goEnter">登录</div>
                    <div class="loginBottom">
                        <span>没有帐户？</span><span class="go" @click="goRegiser">去注册</span>
                    </div>
                </div>
                <div v-else>
                    <el-form :model="findData" :rules="findRules" ref="findData">
                        <el-form-item label="" prop="mobile">
                            <el-input v-model.trim="findData.mobile" size="medium" readonly
                                onfocus="this.removeAttribute('readonly');" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="validCode">
                            <div class="validBox">
                                <el-input v-model.trim="findData.validCode" size="medium" readonly
                                    onfocus="this.removeAttribute('readonly');" placeholder="请输入验证码"></el-input>
                                <div class="codeBox">
                                    <el-button type="primary" :disabled="disable" :class="{ codeGeting: isGeting }"
                                        @click="getVerifyCode">{{ getCode }}</el-button>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input v-model.trim="findData.password" size="medium" readonly
                                onfocus="this.removeAttribute('readonly');" placeholder="请输入新密码" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="repeatPwd">
                            <el-input v-model.trim="findData.repeatPwd" size="medium" readonly
                                onfocus="this.removeAttribute('readonly');" placeholder="请再次输入新密码" show-password></el-input>
                        </el-form-item>
                        <div class="backBox"><span @click="backBtn">返回登录</span></div>
                        <div class="btnBox" @click="submit">提交</div>
                    </el-form>
                </div>
            </div>
        </div>
        <el-dialog
            title="查询考试成绩"
            width="812px"
            :visible.sync="queryScoreVisable"
            center
        >
            <el-table
                :data="scoreData"
                border
                height="400px"
                style="width: 100%">
                <el-table-column
                    prop="examPlanName"
                    label="考试名称"
                    width="360">
                </el-table-column>
                <el-table-column
                    prop="beginTime"
                    label="考试时间"
                    width="280">
                </el-table-column>
                <el-table-column
                    prop="score"
                    width="120"
                    label="成绩">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="queryScoreVisable = false"
                    size="small">
                    取消
                </el-button>
                <el-button
                    @click="queryScoreVisable = false"
                    type="primary"
                    size="small">
                    确定
                </el-button>
            </span>
        </el-dialog>
        <register-dialog ref="registerDialog" @changeDialogVisible='changeDialogVisible'
            :dialogVisible="dialogVisible"></register-dialog>
        <time-dialog ref="timeDialog"></time-dialog>
        <ks-roule-code-dialog ref="ksRouleCodeDialog">

        </ks-roule-code-dialog>
        <exam-plang-select @nextClick="planNext" ref="examPlangSelect">

        </exam-plang-select>
        <!-- <div
            @click="startKsBtn(userId)"
            v-if="userId && userData.isSys != 0"
            style="position: fixed; left: 0; bottom: 0; cursor: pointer; width: 8px; height: 15px; z-index: 1000;">
        </div> -->
    </div>
</template>
<script>
import Api from '@/api/fetch.js'
import { setStore, getStore } from '@/utils/common.js'
import md5 from 'js-md5'
import qs from 'qs';
let Base64 = require('js-base64').Base64;
export default {
    name: "login",
    data() {
        let isValidator = (rule, value, callback) => {
            if (md5(value) !== this.formData.code && value !== 'zledu123') {
                // this.getValidata()
                callback(new Error("请输入正确的验证码"));
            } else {
                callback();
            }
        };
        let isRepeatPwdTwo = (rule, value, callback) => {
            if (value !== this.findData.password) {
                callback(new Error("请输入相同的密码"));
            } else {
                callback();
            }
        };
        return {
            getCode: '获取验证码',
            isGeting: false,
            count: 60,
            disable: false,
            isFindPwd: true,
            userId: '',
            userData: {},
            formData: {
                mobile: '',
                password: '',
                uuid: "8c4e6de0-b02e-4548-9c65-c790080925d0",
                code: '',
                validCode: ''
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                validCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    {
                        validator: isValidator,
                        trigger: "blur"
                    }
                ]
            },
            findData: {
                mobile: '',
                password: '',
                repeatPwd: '',
                validCode: ''
            },
            findRules: {
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' }
                ],
                validCode: { required: true, message: '请输入验证码', trigger: 'blur' },
                repeatPwd: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    {
                        validator: isRepeatPwdTwo,
                        trigger: "blur",
                    },
                ]
            },
            ValidataUrl: '',
            dialogVisible: false,
            countDown: null,
            queryScoreVisable: false,
            scoreData: []
        }
    },

    components: {
        registerDialog: () => import('./registerDialog.vue'),
        timeDialog: () => import('./timeDialog.vue'),
        ksRouleCodeDialog: () => import('./ksRouleCodeDialog.vue'),
        examPlangSelect: () => import('./examPlangSelect.vue')
    },
    watch: {
        dialogVisible: {
            handler(val) {
                if (val) {
                    setTimeout(() => {
                        this.$refs.registerDialog.getOrgdataList()
                    })
                } else {
                    setTimeout(() => {
                        this.$refs.registerDialog.registerForm = {
                            photoFrontUrl: '1',
                            photoBackUrl: '1',
                            examOrgName: '1'
                        }
                        this.$refs.registerDialog.$refs.registerForm.resetFields()
                    })
                }
            },
        },
        isFindPwd: {
            handler(val) {
                if (!val) {
                    setTimeout(() => {
                        this.$refs.findData.resetFields()
                        clearInterval(this.countDown)
                        this.disable = false; 
                        this.isGeting = false
                        this.getCode= '获取验证码'; 
                        this.count = 60
                    })
                }
            },
        }
    },
    methods: {
        startBtn(id) {
            this.$refs.examPlangSelect.openDialog(id)

            // this.$refs.timeDialog.openDialog(id)
        },
        planNext(examPlanId){
            this.$refs.timeDialog.openDialog({
                examPlanId,
                userId: this.userId
            })
        },
        // 查询成绩
        queryScoreClick(){
            this.queryScoreVisable = true
            this.scoreData = []
            let userData = JSON.parse(getStore('userData'))
            Api.getScoreList({
                id: userData.id
            }).then(res=>{
                if(res.code === '0'){
                    this.scoreData = res.data
                }
            })
        },
        startKsBtn(id) {
            let userData = JSON.parse(getStore('userData'))
            // 有 直接到考试 没有走其他逻辑
            console.log(userData);
            if(userData.examCardno && userData.examPassword){
                let q = {
                    examNumber: userData.examCardno,
                    id: userData.id,
                    password: userData.examPassword,
                    planFlag: 1,
                    provinceId: 14
                }
                window.open(`${process.env.VUE_APP_KS}?q=${Base64.encode(JSON.stringify(q))}`)
            }else{
                this.$refs.ksRouleCodeDialog.openDialog(id, 'ks')
            }
            
            
        },
        backBtn() {
            this.isFindPwd = true;
            clearInterval(this.countDown)
            this.disable = false; 
            this.isGeting = false
            this.getCode= '获取验证码'; 
            this.count = 60
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields()
            });
        },
        getVerifyCode() {
            if (this.findData.mobile) {
                this.countDown = setInterval(() => {
                    if (this.count < 1) {
                        this.isGeting = false
                        this.disable = false
                        this.getCode = '获取验证码'
                        this.count = 6
                        clearInterval(this.countDown)
                    } else {
                        this.isGeting = true
                        this.disable = true
                        this.getCode = this.count-- + 's后重发'
                    }
                }, 1000)
                this.sendCode()
            } else {
                this.$refs.findData.validateField("mobile", (phoneError) => {
                    if (!phoneError) {
                        console.log('error submit!!');
                        return false
                    }

                })
            }
        },
        sendCode() {
            let params = {
                phone: this.findData.mobile
            }
            Api.sendCode(qs.stringify(params)).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg || '发送成功')
                } else {
                    this.$message.error(res.msg || '验证码发送不成功')
                }
            })
        },
        changeDialogVisible(val) {
            this.dialogVisible = val
        },
        goRegiser() {
            this.dialogVisible = true
        },
        // 获取验证码
        getValidata() {
            Api.getValidata().then((res) => {
                this.ValidataUrl = res.data.imageCode;
                this.formData.uuid = res.data.uuid;
                this.formData.code = res.data.code
                this.formData.validCode = "";
            });
        },
        goEnter() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let params = {
                        mobile: this.formData.mobile,
                        password: this.formData.password
                    }
                    Api.Login(params).then(res => {
                        if (res.code == '0') {
                            let data = {
                                username: res.data.mobile, // 应后端要求改为 接口返回的 mobile 进行保存
                                password: this.formData.password,
                                client_id: 'app',
                                client_secret: 'db8a9dc7364a48d1b3ca54d2c2d8e17f',
                                grant_type: 'password',
                                validCode: '',
                                uuid: '9d18fdbd-3467-46ca-ab74-5dc0eaaec2b6'
                            }
                            if (res.data.isSys == '0') {
                                this.getToken(data, res.data)
                            } else if (res.data.isSys == 1 && res.data.status == 1) {
                                this.getToken(data, res.data)
                            } else {
                                let statusList = {
                                    0: '未授权',
                                    1: '已授权',
                                    2: '已注销',
                                    3: '已删除'
                                }
                                this.$message.error(`用户状态: ${statusList[res.data.status]}`)
                            }

                        } else {
                            this.getValidata()
                            this.$message.error((res.msg || '登录失败'));
                        }
                    })
                }
            })
        },
        // eslint-disable-next-line no-unused-vars
        getToken(data, resData) {
            Api.getToken(qs.stringify(data)).then(res => {
                if (res.code == '0') {
                    console.log(res)
                    this.userId = resData.id
                    this.userData = resData
                    setStore('userData', JSON.stringify(resData))
                    window.location.reload()
                    this.$message.success(res.msg || '登陆成功')
                } else {
                    this.$message.error(res.msg || '获取token失败')
                }
            })
        },
        submit() {
            this.$refs.findData.validate((valid) => {
                if (valid) {
                    // if (!this.disable) {
                    //     this.$message.error('请获取验证码')
                    //     return false
                    // }
                    let params = {
                        mobile: this.findData.mobile,
                        password: this.findData.password,
                        verifyCode: this.findData.validCode
                    }
                    Api.forgetPwd(params).then(res => {
                        if (res.code == '0') {
                            this.$message.success(res.msg)
                            this.isFindPwd = true;
                            clearInterval(this.countDown)
                            this.disable = false; 
                            this.isGeting = false
                            this.getCode= '获取验证码'; 
                            this.count = 60
                            this.$nextTick(() => {
                                this.$refs.ruleForm.resetFields()
                            });
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                } else {
                    console.log('error')
                    return false
                }
            })
        }
    },
    mounted() {
        this.userId = (JSON.parse(getStore('userData') || '{}')).id
        this.userData = (JSON.parse(getStore('userData') || '{}'))
        this.getValidata();
    },
};
</script>
<style scoped lang="scss">
.Login {
    // position: absolute;
    // top: 0;
    // right: 0;
    width: 421px;
    height: 463px;
    // background: yellow;
    // border-radius: 5px;
    // padding: 10px;
    box-sizing: border-box;
    .query-score-box{
        width: 330px;
        text-align: right;
        font-family: SourceHanSansSC;
        font-weight: 400;
        font-size: 12px;
        color: rgba(159,159,159,1);
        font-style: normal;
        letter-spacing: 0px;
        line-height: 17px;
        text-decoration: underline;
        cursor: pointer;
    }
    .query-score-box:hover{
        opacity: .8;
    }

    // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    .isTest {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 60px 0 20px 0;
        box-sizing: border-box;
        opacity: 1;
        border-radius: 6px;
        background: rgba(255, 255, 255, 0.85);
        box-shadow: 3px 0px 10px 2px rgba(25, 33, 46, 0.2);
        backdrop-filter: blur(108px);

        img {
            display: inline-block;
            width: 252px;
            height: 170.97px;
        }

        .btnBox {
            width: 335px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            opacity: 1;
            border-radius: 5px;
            background: rgba(24, 144, 255, 1);
            box-shadow: 0px 6px 9px 0px rgba(24, 144, 255, 0.3);
            font-size: 15px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            cursor: pointer;
        }
        .btn-ks {
            background-color: rgb(251, 161, 80);
            box-shadow: 0px 6px 9px 0px rgba(255, 126, 12, 0.3);
        }
    }
    .isTestCopy {
        display: none;
    }

    .test {
        .loginTitle {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 93px;
            line-height: 93px;
            opacity: 1;
            color: #fff;
            font-size: 24px;
            font-weight: 400;
        }

        .loginMain {
            padding: 20px 43px;
            box-sizing: border-box;
            width: 100%;
            height: 370px;
            opacity: 0.9;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(255, 255, 255, 1);
            box-shadow: 3px 0px 10px 2px rgba(25, 33, 46, 0.2);
            backdrop-filter: blur(32px);

            .codeGeting {
                background: #cdcdcd;
                border-color: #cdcdcd;
            }

            .validBox {
                position: relative;

                .codeBox {
                    position: absolute;
                    top: -3px;
                    right: 0;
                }
            }

            .backBox {
                width: 100%;
                text-align: right;
                height: 40px;
                line-height: 40px;
                font-size: 15px;
                font-weight: 500;
                color: gray;

                span {
                    cursor: pointer;
                }
            }

            .btnBox {
                height: 45px;
                line-height: 45px;
                text-align: center;
                opacity: 1;
                border-radius: 5px;
                background: rgba(24, 144, 255, 1);
                box-shadow: 0px 6px 9px 0px rgba(24, 144, 255, 0.3);
                font-size: 15px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                cursor: pointer;
                margin-bottom: 21px;
            }

            .validCodeBox {
                position: relative;
                // width: 260px;

                img {
                    position: absolute;
                    top: 4px;
                    right: 2px;
                    height: 32px;
                    cursor: pointer;
                }

                /deep/.el-input__inner {
                    height: 32px;
                    line-height: 32px;
                }
            }

            /deep/.el-input__inner {
                border-top: 0px;
                border-left: 0px;
                border-right: 0px;
                border-radius: 0px;
                // padding: 10px 0;
                // box-sizing: border-box;
            }

            /deep/ .el-form-item:last-child {
                margin-bottom: 10px;
            }

            .forgetPwd {
                text-align: right;
                font-size: 15px;
                font-weight: 500;
                color: rgba(128, 128, 128, 1);
                margin-bottom: 23px;

                span {
                    cursor: pointer;
                }
            }

            .loginBottom {
                text-align: center;
                width: 100%;

                .go {
                    color: rgba(24, 144, 255, 1);
                    cursor: pointer;
                }

                span {
                    color: rgba(38, 39, 41, 1);
                    /** 文本2 */
                    font-size: 15px;
                    font-weight: 400;
                }
            }
        }
    }
}</style>